import { FC, ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Lock } from '@mui/icons-material'

import { LockedFeatureId } from '../../types/LockedFeature'
import { GRBanner } from '../GRBanner/GRBanner'
import { LockedFeature } from '../LockedFeature/LockedFeature'

/**
 * Component for displaying limited functionality banner. Clicking the banner opens locked feature dialog with
 * content based on the given lockedFeatureId prop.
 */

type LimitedFunctionalityBannerProps = {
  lockedFeatureId: LockedFeatureId
  children?: ReactNode
  href?: string
}

export const LimitedFunctionalityBanner: FC<LimitedFunctionalityBannerProps> = ({ lockedFeatureId, children, href }) => {
  const { t } = useTranslation()
  const [lockedFeatureDialogOpen, setLockedFeatureDialogOpen] = useState<boolean>(false)
  const banner = (
    <GRBanner severity="success" icon={<Lock />} onClick={href ? undefined : () => setLockedFeatureDialogOpen(true)}>
      {children || t('common:limited_functionality_banner')}
    </GRBanner>
  )

  return (
    <>
      {href ? (
        <a href={href} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
          {banner}
        </a>
      ) : (
        banner
      )}
      {!href && <LockedFeature.Dialog lockedFeatureId={lockedFeatureId} open={lockedFeatureDialogOpen} onClose={() => setLockedFeatureDialogOpen(false)} />}
    </>
  )
}
